import ContactLayout from "Layout/ContactLayout";
import React from "react";

export default function AboutUs() {
  return (
    <ContactLayout heading="About Us">
      <div className="about">
        <main>
          <h1>Welcome</h1>
          <div className="about_content">
            <div className="left">
              <p>
                Kazfield Integrated Services Ltd is an estate development and
                brokerage firm. We specialize in estate development. Currently,
                we have five ongoing projects: Brodny Residence Igbonla, Brodny
                Residence Extension facing Ketu-Epe Expressway, Brodny City
                Igbodu Molajoye, and Brodny Height Ketu-Epe. These four projects
                are located in Epe. The fifth project is Brodny Smart Terrace in
                Abijo, Lekki, Lagos, Nigeria.
              </p>
              <p>
                In addition to our development projects, we are committed to
                providing brokerage services. Our primary focus is assisting
                investors in securing genuine landed properties without any
                hassle. We have successfully helped numerous clients both
                locally and internationally.
              </p>
              <p>
                We are Nigeria’s largest commercial and residential real estate
                sales organization. Our team of dedicated professionals gives
                the best advice and services to ensure the success of your
                property.
              </p>
            </div>
            <div className="right">
              <p>
                We specialize in commercial and residential property sales. We
                offer a wide variety of services including house price guide,
                market reports and statistics, property search, Property Finder,
                Properties Wanted, Property Leads and Property Dealers listings
                on property websites like the Nigeria Property Portal.
              </p>
              {/* <p>
                Our vision is to be the most trusted name in our industry by
                providing exceptional service and outstanding value. We're
                excited about collaborating with our clients as we work together
                to make their real estate dreams come true
              </p> */}
              <p>
                As a leading Real Estate sales agency in Nigeria , we offer
                unique services to help you find your home. We will ensure that
                you are well informed of all recent developments in the market,
                current opportunities and details of the unique properties
                available at advantageous prices. Our team will provide
                appropriate advice on the products being targeted in your local
                market
              </p>
            </div>
          </div>
        </main>
        <div className="our_teams">
          <h1>Meet Our Team</h1>

          <div className="gallery">
            <ul>
              <li>
                <div className="image">
                  <img src="/image/04.jpeg" alt="" />
                  <div className="info">
                    <div className="name"> Kazeem Yekinni </div>
                    <div className="position">CEO</div>
                  </div>
                </div>
              </li>

              <li>
                <div className="image">
                  <img src="/image/05.jpeg" alt="" />
                  <div className="info">
                    <div className="name"> Tomiwa Ogunremi</div>
                    <div className="position">Project Manager</div>
                  </div>
                </div>
              </li>

              <li>
                <div className="image">
                  <img src="/image/06.jpeg" alt="" />
                  <div className="info">
                    <div className="name"> Adekanmi Adedara Adeyemi </div>
                    <div className="position"> I.T Specilist </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ContactLayout>
  );
}
